import rootApi from '@utils/baseAPI/WrapperApi';

export const apiGetAllCustomer = (data) => {
  return rootApi.get('api/customers', { params: data });
};

export const apiGetAllCustomerByeReplacementType = (data) => {
  return rootApi.get('api/customers/by-replacement-type', { params: data });
};

export const apiGetAllCustomerWithDevice = (data) => {
  return rootApi.get('api/customers/device', { params: data });
};

export const apiGetCustomerById = (id) => {
  return rootApi.get(`api/customer/${id}`);
};

export const apiCreateCustomer = (data) => rootApi.post('api/customer', data);
export const apiUpdateCustomer = (data, id) => rootApi.put(`api/customer/${id}`, data);
export const apiDeleteCustomer = (id) => rootApi.delete(`api/customer/${id}`);

export const apiDownloadTemplate = (data) => rootApi.post('api/customer/export-template', data);
export const apiImportExcel = (data) => rootApi.post('api/customer/import', data);

export const apiGetStatisticsData = (data) => {
  return rootApi.get('api/customer/statistics', { params: data });
};

export const apiGetStatisticsCustomerByDay = (data) => {
  return rootApi.get('api/customer/v2/statistics-customer-by-day', { params: data });
};

export const apiExportStatisticsReport = (data) => {
  return rootApi.get('api/customer/export-statistics-report', { params: data });
};

export const apiGetStatisticsDataByMonth = (data) => {
  return rootApi.get('api/customer/consumptions-by-month', { params: data });
};

export const apiGetStatisticsDataByMonthV2 = (data) => {
  return rootApi.get('api/customer/v2/statistics', { params: data });
};

export const apiGetStatisticsDataByMonthByCustomerV2 = (data) => {
  return rootApi.get('api/customer/v2/statistics-by-customer', { params: data });
};

export const apiGetStatisticsDataByMonthDetail = (data) => {
  return rootApi.get('api/customer/consumption-by-month/detail', { params: data });
};
